import { render } from "./SalesManagementPage.vue?vue&type=template&id=622c20d7"
import script from "./SalesManagementPage.vue?vue&type=script&lang=js"
export * from "./SalesManagementPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__